// Force build counter: 2
import React from 'react'
import ReactDOM from 'react-dom'
import { Route, Switch } from 'react-router'
import { BrowserRouter } from 'react-router-dom'
import ApprovePage from './approve'
import { TranslatorProvider } from './common/translator'
import OrganizationPage from './organization'
import './polyfills'

import './styles/app.sass'

ReactDOM.render(
  <React.StrictMode>
    <TranslatorProvider>
      <BrowserRouter>
        <Switch>
          <Route path="/hyvaksytys/:approve_id" component={ApprovePage} />
          <Route path="/yritys/:organization_id" component={OrganizationPage} />
        </Switch>
      </BrowserRouter>
    </TranslatorProvider>
  </React.StrictMode>,
  document.getElementById('app')
)
